import React from 'react';
// import { Link } from 'react-router-dom';
// import facebook from '../assets/images/facebook.svg';
// import instragram from '../assets/images/instagram.svg';
// import twitter from '../assets/images/twitter.svg';
// import youtube from '../assets/images/youtube-icon.svg';
// import terms from '../assets/files/terms-conditions.pdf';
// import vimeo from '../assets/images/Vimeo.svg';
// import linkedin from '../assets/images/LinkedIn.svg';
import { Box, Link } from '@mui/material';
import logo from '../assets/images/skyguide_logo.png';
import { useTranslation } from 'react-i18next';


// For social media if it's needed
// <Box sx='socials-info'>
	// <Box sx='socials-title'>REDES SOCIALES</Box>
	// <Box sx='socials-container'>
		// <p><a href='https://www.facebook.com/UniandesCol/' target='_blank' rel="noopener noreferrer"><img src={facebook} alt='face'></img></a></p>
		// <p><a href='https://www.instagram.com/uniandes/' target='_blank' rel="noopener noreferrer"><img src={instragram} alt='ins'></img></a></p>
		// <p><a href='https://twitter.com/Uniandes' target='_blank' rel="noopener noreferrer"><img src={twitter} alt='twi'></img></a></p>
		// <p><a href='https://www.youtube.com/user/uniandes' target='_blank' rel="noopener noreferrer"><img src={youtube} alt='youtu'></img></a></p>
		// <p><a href='https://vimeo.com/uniandes' target='_blank' rel="noopener noreferrer"><img src={vimeo} alt='vimeo'></img></a></p>
		// <p><a href='https://www.snapchat.com/add/uniandesco' target='_blank' rel="noopener noreferrer"><img src={snapchat} alt='snapchat'></img></a></p>
		// <p><a href='https://www.linkedin.com/school/universidad-de-los-andes/' target='_blank' rel="noopener noreferrer"><img src={linkedin} alt='linkedin'></img></a></p>
	// </Box>
// </Box> */}

// For external pages
// <Box sx='quick-links'>
	// <Box sx='quick-title'>ENLACES RÁPIDOS</Box>
		// <Box sx='terms-conditions'>
			// <p><Link to='/' style={{textDecoration: 'none', color: '#818181', width: '100%'}} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Home</Link></p>
			// <p><a href={terms} target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: '#818181'}}>Términos y condiciones</a></p>
			// <p><a href='https://secretariageneral.uniandes.edu.co/images/documents/Manual-Politica-Tratamiento-Datos-Personales-2020-Uniandes.pdf' target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: '#818181'}}>Politica de privacidad</a></p>
			// <p><a href='https://servicios.uniandes.edu.co/' target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: '#818181'}}>Servicios</a></p>
			// <p><a href='https://ghdo.uniandes.edu.co/index.php/es/' target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: '#818181'}}>Administrativos</a></p>
			// <p><a href='https://servicios.uniandes.edu.co/consulta-medica/' target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: '#818181'}}>Emergencias: Extensión 0000</a></p>
			// <p><a href='https://campusinfo.uniandes.edu.co/recorridovirtual' target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: '#818181'}}>Recorrido Virtual</a></p>
		// </Box>
	// </Box>

const classes = {
	contactInfoContainer: {
		display: 'table',
		margin: '0 auto',
		width: '100%',
		'& .phone-info': {
			fontSize: '.75rem',
			color: 'white',
			lineHeight: 1,
			textAlign: 'center',
			borderLeft: '1px solid #232323',
			display: 'table-cell',
			'& p': {
				lineHeight: 2
			}
		},
	},
	footerSection: {	
		backgroundColor: '#1e283c',
		width: '100%',
		display: 'flex',
		justifyContent: 'space-between',
		paddingLeft: '10%',
		paddingRight: '10%',
		alignItems: 'center',
		'@media (max-width:768px)': {
			flexDirection: 'column',
			paddingTop: '8px',
		},
	},
	contact: {
		margin: '0px !important',
		fontWeight: 'bold',
		fontSize: '22px',
		color: '#ffffff',
		fontFamily: 'TT-Interphases-Regular',
	},
	emailInfo: {
		color: '#ffffff',
		fontSize: '20px',
		fontFamily: 'TT-Interphases-Regular',
	},
  logoMobile: {
    display: 'flex',
		'@media (max-width:768px)': {
			marginTop: '8px',
		},
  },
	mail: {
		textDecoration: 'underline',
		color: 'white',
		fontWeight: 'bold',
	},
};

function Footer({ contactEmail }){
	const { t } = useTranslation();
  return(
		<>
			<Box sx={classes.footerSection}>
				<Link sx={classes.logoMobile} to='/'>
					<img style={{ height: '60px' }} src={logo}	alt='lo' />
				</Link>
				<Box sx={classes.contactInfoContainer}>
						<Box sx={classes.addressInfo}>
							<p style={classes.contact}>
								{t('contact')}
							</p>
						</Box>
						<Box sx={classes.emailInfo}>
							<p>
								{contactEmail ? (
									<a
										style={classes.mail}
										href={`mailto:${contactEmail}`}
									>
										{contactEmail}
									</a>
								) : (
									<>
										{t('contactDesc')}<br />
										<a
											style={classes.mail}
											href={'mailto:work@skyguide.ch'}
										>
											work@skyguide.ch
										</a>
									</>
								)}
							</p>
						</Box>
				</Box>
			</Box>
		</>
	)
}

export default (Footer);